import { render, staticRenderFns } from "./shareGoods.vue?vue&type=template&id=75e051c6&scoped=true"
import script from "./shareGoods.vue?vue&type=script&lang=js"
export * from "./shareGoods.vue?vue&type=script&lang=js"
import style0 from "./shareGoods.vue?vue&type=style&index=0&id=75e051c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e051c6",
  null
  
)

export default component.exports